import safeStorage from '@github-ui/safe-storage'

export type PreviousPageInfo = {title: string; url: string}

const COPILOT_PREVIOUS_PAGE_TITLE_KEY = 'COPILOT_PREVIOUS_PAGE_TITLE_KEY'
const tempStorage = safeStorage('localStorage', {
  throwQuotaErrorsOnSet: false,
  ttl: 1000 * 60 * 30, // 30 minutes
})

export function getPreviousPageInfo(): PreviousPageInfo | null {
  const val = tempStorage.getItem(COPILOT_PREVIOUS_PAGE_TITLE_KEY)
  if (!val) return null
  try {
    const parsed = JSON.parse(val) as PreviousPageInfo
    if (typeof parsed.title === 'string' && typeof parsed.url === 'string') {
      return parsed
    }
    return null
  } catch {
    return null
  }
}

export function setPreviousPageInfo(title: string | null): void {
  const key = COPILOT_PREVIOUS_PAGE_TITLE_KEY
  if (title === null) {
    tempStorage.removeItem(key)
    return
  }

  tempStorage.setItem(key, JSON.stringify({title, url: document.location.href}))
}
